import { EVENT_KEY_ORIGIN, MESSAGE_KEY_CAN_RENDER_FORM, MESSAGE_KEY_CUSTOM_HTML_WIDGET, MESSAGE_KEY_CUSTOM_VALIDATE_MESSAGE, MESSAGE_KEY_ON_CAPTCHA_TOKEN, MESSAGE_KEY_ORIGIN, MESSAGE_KEY_RENDER_TERM_AND_CONDITION_CONTENT, RENDER_MODE_ON_SITE, URL_PARAMETER_RECIPIENT_ORIGIN, URL_PARAMETER_RENDER_MODE } from "../../core/const/Constant.js";
import { TXT_ERROR_DOMAIN_NOT_ALLOWED, TXT_ERROR_INTERNAL_MESSAGE, TXT_FORM_ENDED, TXT_FORM_NOT_STARTED_YET, TXT_SUCCESS_SUBMIT_FORM } from "../const/String.js";
import FormModel from "../models/FormModel.js";
import Observer from "../services/Observer.js";
import Logger from "../../core/utils/Logger.js";
import Utils from "../utils/Common.util.js";
import {
    NewWidget
} from '../widgets/index.js';
import TaiBaseComponent from "./_base.js";
import { setRecipientOrigin, subscribeMessageOnce } from "../../core/services/MessageService.js";
import Message from "../services/WindowMessage.js";
import { APP_ORIGIN, __ENV } from "../../ENV.js";
import TaiBaseWidget from "../widgets/base.widget.js";
import { isIframe } from "../../core/common/Common.js";
import { doRenderCaptcha, doGetRecaptchaToken } from "../services/Recaptcha.js";
import { getForm, submitForm } from "../api/form.api.js";
import { useSubcribeWindowMessage } from "../hook/useSubcribeWindowMessage.js";



const getInitParentOrigin = (() => {
    let origin = Utils.QueryUrlParameter(URL_PARAMETER_RECIPIENT_ORIGIN);
    return () => origin
})()

const isOrginAllowed = (currentOrigin, configOrigin) => currentOrigin.startsWith(configOrigin) || currentOrigin === APP_ORIGIN;


const extractErrorMessage = (() => {
    const msgByKey = {
        'recapcha_data': 'Recaptcha Invalid'
    }

    return message => {
        if (message) {
            const mesg = Object.keys(message).map(k => msgByKey[k]).filter(item => !!item).join(', ');
            return mesg;
        }
        return TXT_ERROR_INTERNAL_MESSAGE;
    }
})();

const formResponseStatus = {
    DOMAIN_NOT_ALLOWED: 'domain_not_allow',
    SUBMIT_FULLY: 'submit_fully',
    ENDED: 'has_end',
    SUBMIT_SUCCESS: 'submit_success',
    FORM_FETCHED: 'form_fetched',
    INTERNAL_ERROR: 'internal_error',
    OTHER_ERROR: 'other_error',
    NOT_YET: 'not_yet',
    VALIDATION_ERROR: 'invalid_data'
}

/**
 * 
 * @param {*} param0 
 * @param {*} currentOrigin 
 * @returns {{...formResponseStatus}}
 */
const responseCase = ({ data, status, responseForm, message }, currentOrigin) => {
    const { domain } = data || { 'domain': null };
    if (status && !isOrginAllowed(currentOrigin, domain)) {
        return formResponseStatus.DOMAIN_NOT_ALLOWED;
    } else if (status && data) {
        return formResponseStatus.FORM_FETCHED
    } else if (!status && responseForm) {
        const { status_form } = responseForm;
        /* this same to api return*/
        return status_form
    } else if (!status && !responseForm && !message) {
        return formResponseStatus.INTERNAL_ERROR;
    } else if (!status) {
        return formResponseStatus.OTHER_ERROR
    }
}

const canRender = (() => {
    const isIFrame = () => Utils.IsIFrame();
    const isRenderAsIFrameMode = () => Utils.IsIFrame() && Utils.QueryUrlParameter(URL_PARAMETER_RENDER_MODE) !== RENDER_MODE_ON_SITE

    return () => !isIFrame() || isRenderAsIFrameMode();

})();

const switchOrigin = (origin, configOrigin) => {
    if (Utils.IsIFrame()) {
        return origin === APP_ORIGIN ? origin : configOrigin
    } else {
        return APP_ORIGIN;
    }
}


const { bindFormExitPrompt, removeFormExitPrompt } = (() => {
    const func = ev => {
        // ev.preventDefault();
        // ev.returnValue = true;
    }
    /**
     * 
     * @type {[Function, Function]}
     */
    return {
        bindFormExitPrompt: () => window.addEventListener("beforeunload", func),
        removeFormExitPrompt: () => window.removeEventListener("beforeunload", func)
    }
})();

const SUBMIT_STATUS = {
    SUBMITTING: 'is-submitting',
    SUBMIT_SUCCESS: 'submit-success',
    NONE: ''
}

const isPreviewMode = () => {
    return Utils.QueryUrlParameter('preview') === '1'
}

const isOnSiteMode = () => {
    return Utils.QueryUrlParameter(URL_PARAMETER_RENDER_MODE) === RENDER_MODE_ON_SITE;
}

/**
 * 
 * @param {FormModel} formModel 
 */
const generatePreview = (formModel) => {

}

class TaiForm extends TaiBaseComponent {

    /**@type FormModel */
    formModel = new FormModel();

    /** @type {Set<TaiBaseWidget>} */
    widgets = new Set();
    isShowingPreview = false;

    onInitialized() {
        this.setShowSekeletonLoading(true);
        this.prepareForm()
            .then(() => {
                if (this.formModel.errorMsg.length > 0) {
                    return;
                }
                if (!canRender()) {
                    return;
                };
                this.onFormPrepared();
            }).finally(() => {
                this.setShowSekeletonLoading(false);
            });
    }

    async waitPingCanRender() {
        await new Promise(next => subscribeMessageOnce(MESSAGE_KEY_CAN_RENDER_FORM, (allow) => {
            if (allow) {
                next()
            }
        }))
    }

    async onFormPrepared() {
        bindFormExitPrompt();

        try {
            Message.PostFormBeforeRender();
            await this.waitPingCanRender();
            doRenderCaptcha(this.formModel);
            this.selfRoot = Utils.HtmlToDom(this.templates());
            this.containerElement.insertBefore(this.selfRoot, this.containerElement.children[0]);
            this.renderWidgets();
            this.bindEvent();

            Observer.SubscribeResize(this.selfRoot, (entries) => {
                this.doPostSize();
            });
            this.setShowSekeletonLoading(false);
        } catch (exeption) {
            Logger.error('[TaiForm]', exeption)
        }
    }

    async prepareForm() {
        try {
            await this.fetchData();
        } catch (err) {
            Logger.error('[TaiForm]', err)
        }
    }

    doPostSize(width = this.selfRoot.offsetWidth, height = this.selfRoot.offsetHeight) {
        Message.PostResize(width, height);
    }

    templates() {
        if (this.formModel.errorMsg.length > 0) {
            return `
            <div class='tai-form'>
                <span class='tai-form__error'>${this.formModel.errorMsg}</span>
            </div>`;
        }

        return /*html*/`
            <div class='tai-form ${this.formModel.hasEnded ? 'ended' : ''}'>
                <div class="tai-form__background"></div>
                <div class="tai-form__banner"></div>
                <div class="tai-form__items"></div>
                <div class="tai-form__preview"></div>
                <div class="tai-form__submit">
                    <div class="tai-error">
                        <span class="f-msg"></span>
                    </div>
                    <div class="tai-field">
                        <button data-tai-back-cta id="btnMoveBack" type='button' class="btn-grey tai-control">
                            <span>
                                Back
                            </span>
                        </button>
                        <button data-tai-next-cta id="btnMoveNext" type='button' class="btn-main tai-control">
                            <span>
                                Next
                            </span>
                        </button>
                        <button id='btnSubmit' type='button' data-tai-submit-cta class="btn-main tai-control">
                            <span>
                                Submit
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        `
    }

    setPageError(msg) {
        super.setPageError(msg);
        this.formModel.setError(msg);
    }

    async fetchData() {
        const response = await getForm(this.uuid);
        const respCase = responseCase(response, this.origin);

        setRecipientOrigin(getInitParentOrigin());
        switch (respCase) {
            case formResponseStatus.DOMAIN_NOT_ALLOWED:
                this.setPageError(TXT_ERROR_DOMAIN_NOT_ALLOWED);
                break;
            case formResponseStatus.FORM_FETCHED:
                const { data } = response;
                this.formModel = new FormModel().fromJSON(data);
                this.onFormFetched();
                break;
            case formResponseStatus.SUBMIT_FULLY:
                const { on_closure_redirect, } = response?.responseForm || { on_closure_redirect: '' };
                Message.PostRedirectTo(on_closure_redirect || '/');
                break;
            case formResponseStatus.ENDED:
                const { message_form } = response?.responseForm || { message_form: '' };
                const redictectUrl = response?.responseForm?.on_closure_redirect || '';
                const formData = response.data;
                if (redictectUrl && redictectUrl.length > 0) {
                    Message.PostRedirectTo(redictectUrl);
                }
                if (typeof formData === 'object' && formData !== null) {
                    this.formModel = new FormModel().fromJSON(formData);
                    this.formModel.hasEnded = true;
                    this.onFormFetched();
                }
                break;
            case formResponseStatus.INTERNAL_ERROR:
                this.setPageError(TXT_ERROR_INTERNAL_MESSAGE);
                Message.PostFormReady();
                break;
            case formResponseStatus.OTHER_ERROR:
                const { message } = response;
                this.setPageError(message);
                // Message.PostFormReady();
                break;
            case formResponseStatus.NOT_YET:
                const { message_form: erroMesg } = response?.responseForm || { message_form: '' };
                this.setPageError(erroMesg || TXT_FORM_NOT_STARTED_YET)
                // Message.PostFormReady();
                break;
        }
    }

    onFormFetched() {
        const { allowOrigin } = this.formModel;
        setRecipientOrigin(switchOrigin(this.origin, allowOrigin));
        Message.PostFormReady();
    }

    renderWidgets() {
        const fragment = document.createDocumentFragment();
        const fields = this.formModel.getFields();
        this.widgets.clear();
        fields.forEach(item => {
            const widget = NewWidget(item.type, item);
            if (widget) {
                this.widgets.add(widget);
                // this.formModel.updateFieldModel(widget.fieldModel);
                fragment.appendChild(widget.getDOM());
            } else {
                Logger.error("[Widgets]", `${item.type} is empty`)
            }
        });
        this.querySelector('.tai-form__items').innerHTML = '';
        this.querySelector('.tai-form__items').appendChild(fragment);
        Message.PostFormRendered();
    }

    onRendered() {
        super.onRendered();
        this.onPageChanged(false);
    }

    bindEvent() {
        this.selfRoot?.addEventListener('click', (e) => {
            const target = e.target || e.currentTarget;
            const [
                isNextClicked,
                isBackClicked,
                isSubmitClicked
            ] = [
                    this.isElementContain(target, '#btnMoveNext'),
                    this.isElementContain(target, '#btnMoveBack'),
                    this.isElementContain(target, '#btnSubmit'),
                ]
            if (isNextClicked) {
                this.nextPage();
            } else if (isBackClicked) {
                this.backPage();
            }
        });

        const btnSubmit = this.querySelector('#btnSubmit');

        if (btnSubmit)
            this.querySelector('#btnSubmit').addEventListener('click', (e) => {
                this.doSubmit()
            })
    }


    renderPreview() {
        const html = this.formModel.fields.reduce((html, target) => {
            if (target.userResponse && target.userResponse.length > 0) {
                html += `<div class='preview-item' data-field-code='${target.code}'><span>${target.title}</span><span>${target.userResponse}</span></div>`
            }
            return html;
        }, '');
        this.querySelector('.tai-form__items').style.display = 'none'
        this.querySelector('.tai-form__preview').innerHTML = `<div class='preview-holder'>${html}</div>`
    }

    nextPage() {
        if (!this.doValidate()) {
            return;
        }
        if (this.formModel.getPageIndex() === this.formModel.totalPage() - 1) {
            this.isShowingPreview = true;
            this.renderPreview();
            this.onPageChanged();
            Message.PostFormPageChanged('preview')
            return;
        }
        const hasChanged = this.formModel.setPageIndex(this.formModel.getPageIndex() + 1);
        if (hasChanged) {
            this.renderWidgets();
            this.onPageChanged();
        }
    }

    backPage() {
        let hasChanged = false;
        if (this.isShowingPreview) {
            this.querySelector('.tai-form__items').style.display = ''
            this.querySelector('.tai-form__preview').innerHTML = ''
            this.isShowingPreview = false;
            hasChanged = true;

        } else {
            hasChanged = this.formModel.setPageIndex(this.formModel.getPageIndex() - 1);
        }
        if (hasChanged) {
            this.renderWidgets();
            this.onPageChanged();
        }
    }

    onPageChanged(needPostPageChange = true) {

        this.querySelector('#btnSubmit').style.display = 'none';
        this.querySelector('#btnMoveNext').style.display = 'none';
        this.querySelector('#btnMoveBack').style.display = 'none';

        if (!this.formModel.hasPaging()) {
            this.querySelector('#btnSubmit').style.display = 'block';
        } else if (this.formModel.isLastPage() && this.isShowingPreview && this.formModel.previewSubmission) {
            this.querySelector('#btnSubmit').style.display = '';
            this.querySelector('#btnMoveBack').style.display = '';
        } else if (this.formModel.getPageIndex() === 0) {
            this.querySelector('#btnMoveNext').style.display = '';
        } else {
            this.querySelector('#btnMoveBack').style.display = '';
            this.querySelector('#btnMoveNext').style.display = '';
        }
        if (needPostPageChange) {
            Message.PostFormPageChanged(this.formModel.getPageIndex())
        }
    }

    getValues() {
        return doGetRecaptchaToken(this.formModel)
            .then(token => {
                const data = this.formModel.toUserResponses();
                if (this.formModel.isExistCaptcha) {
                    data.push({
                        'code': 'recapcha_data',
                        'value': token
                    })
                }
                return Promise.resolve(data);
            })
    }

    setFormError(errorObj) {
        if (!errorObj) {
            this.removeClass('is-submit-error')
            this.querySelector('.tai-form__submit .tai-error .f-msg').innerText = '';
            return;
        }
        const { message, status } = errorObj;
        let msg = '';
        if (message && typeof message === 'object') {
            this.setWidgetErrorMessage(message)
        } else if (message && typeof message === 'string') {
            msg = message;
        } else {
            msg = extractErrorMessage(message);
        }
        if (msg.length > 0) {
            this.addClass('is-submit-error')
        } else {
            this.removeClass('is-submit-error')
        }
        this.querySelector('.tai-form__submit .tai-error .f-msg').innerText = msg;
    }

    clearForm() {
        this.widgets.forEach(widget => widget.clearValue());
        this.setFormError(false);
    }

    doValidate() {
        let isValid = true;
        /** @type {TaiBaseWidget | undefined} */
        let firstErrorWidget;
        this.widgets.forEach(widget => {
            if (!widget.doValidate()) {
                isValid = false;
                firstErrorWidget = firstErrorWidget || widget;
            }
        });
        if (firstErrorWidget) {
            firstErrorWidget.scrollIntoView();
        }
        return isValid;
    }

    doRedirectOnSuccess(isUnique = true) {
        if (isPreviewMode()) {
            return;
        }
        const { redirectSuccessUrl, redirectSuccessUrlWhenNotUnique, isRedirectSuccessUrlValid } = this.formModel;
        const realRedirectUrl = isUnique ? redirectSuccessUrl : redirectSuccessUrlWhenNotUnique;
        if (isRedirectSuccessUrlValid && isIframe() && isOnSiteMode()) {
            Message.PostRedirectTo(realRedirectUrl)
        } else if (isRedirectSuccessUrlValid && !isOnSiteMode()) {
            window.location.href = realRedirectUrl;
        }
    }

    setSubmitStatus(status) {
        this.removeClass(Object.values(SUBMIT_STATUS));
        this.addClass(status);
    }

    submitSuccess() {
        Message.PostSubmitFormSuccess();
        removeFormExitPrompt();
        this.setSubmitStatus(SUBMIT_STATUS.SUBMIT_SUCCESS);
        this.clearForm();
    }

    setWidgetErrorMessage(errorObj) {
        for (let fieldCode in errorObj) {
            const message = Object.values(errorObj[fieldCode]).join(', ')
            this.formModel.setFieldError(fieldCode, message);
        }
    }

    doSubmit() {
        if (this.formModel.hasEnded) {
            return
        }
        if (!this.doValidate()) {
            return;
        }
        this.setSubmitStatus(SUBMIT_STATUS.SUBMITTING);

        this.getValues()
            .then(data => {
                return submitForm(this.formModel.uuid, data);
            }).then((response) => {
                const { status } = response;
                if (status) {
                    this.submitSuccess();
                    const { is_unique_submit } = response.responseForm;
                    this.doRedirectOnSuccess(is_unique_submit)
                } else if (!status) {
                    this.setSubmitStatus(SUBMIT_STATUS.NONE);
                    return Promise.reject(response);
                }
            }).catch((error) => {
                this.setFormError(error);
                Logger.info("Submit Failed!", error);
                Message.PostSubmitFormFailed(error);
            }).finally(() => {
                Utils.Delay(1000).then(() => this.setSubmitStatus(SUBMIT_STATUS.NONE))
            })
    }

}

export default TaiForm; 